'use client';
import { primaryShade } from '../primaryShade/primaryShade.js';
import { rgba } from '../rgba/rgba.js';

var getGradientBreakpoints = function(colors) {
    var stops = "";
    for(var i = 1; i < colors.length - 1; i += 1){
        stops += colors[i] + " " + i / (colors.length - 1) * 100 + "%, ";
    }
    return colors[0] + " 0%, " + stops + colors[colors.length - 1] + " 100%";
};
var gradient = function(theme) {
    var optionalOpaque = function(color, opacity) {
        if (opacity) {
            return rgba(color, opacity);
        }
        return color;
    };
    var gradient = function(options) {
        var _ref = options || {}, from = _ref.from, to = _ref.to, _ref_deg = _ref.deg, deg = _ref_deg === void 0 ? 0 : _ref_deg, opacity = _ref.opacity;
        var shadeFrom = optionalOpaque(primaryShade(theme.fn.themeColor(from)), opacity);
        var shadeTo = optionalOpaque(primaryShade(theme.fn.themeColor(to)), opacity);
        return "linear-gradient(" + deg + "deg, " + shadeFrom + " 0%, " + shadeTo + " 100%)";
    };
    gradient.linear = function(deg) {
        for(var _len = arguments.length, colors = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            colors[_key - 1] = arguments[_key];
        }
        return "linear-gradient(" + deg + "deg, " + getGradientBreakpoints(colors) + ")";
    };
    gradient.radial = function() {
        for(var _len = arguments.length, colors = new Array(_len), _key = 0; _key < _len; _key++){
            colors[_key] = arguments[_key];
        }
        return "radial-gradient(circle, " + getGradientBreakpoints(colors) + ")";
    };
    return gradient;
};

export { getGradientBreakpoints, gradient };
